import { Frequency } from '@guestgoodie/helpers'
import { Trans, useLingui } from '@lingui/react/macro'

import Input from '@/components/ui/Input'
import { useMemo } from 'react'

function useFrequencyToIntervalLabel(freq: Frequency) {
  const { t } = useLingui()

  return useMemo(() => {
    switch (freq) {
      case Frequency.DAILY:
        return t`Day`
      case Frequency.WEEKLY:
        return t`Week`
      case Frequency.MONTHLY:
        return t`Month`
      case Frequency.YEARLY:
        return t`Year`
    }
  }, [freq, t])
}

export function IntervalInput({
  value,
  freq,
  onChange
}: {
  value: number
  freq: Frequency
  onChange: (value: number) => void
}) {
  const label = useFrequencyToIntervalLabel(freq)

  return (
    <label className="flex flex-row items-center gap-2">
      <span>
        <Trans>Every</Trans>
      </span>
      <Input
        type="number"
        className="w-20"
        min={1}
        value={value}
        onChange={event => onChange(parseInt(event.target.value))}
      />
      <span>{label}</span>
    </label>
  )
}
